module.exports = __webpack_public_path__ + "img/img02.148537a0.jpeg";